export default __webpack_public_path__ + "2535ac46aa5aae270a8fb9264e794ef3.gif";